export enum CreditCardType {
  Visa = 'Visa',
  MasterCard = 'MasterCard',
  AmericanExpress = 'AmericanExpress',
  Discover = 'Discover',
  JCB = 'JCB',
  DinersClub = 'DinersClub',
}

export interface CreditCardDetails {
  /** The customer’s masked credit card number */
  cardNumber: string;

  /** The expiration date for the customer’s credit card (7 characters) */
  expirationDate: string;

  /** Type of credit card */
  cardType: CreditCardType;

  /**
   * Used for testing only. Setting this in the DB will simulate a specific payment failure.
   *
   * | mode value         | simulates                                         |
   * |--------------------|---------------------------------------------------|
   * | `error`            | generic processor error (TEST: Test Error)        |
   * | `error_declined`   | card declined by issuer (ANet code 2)             |
   * | `error_avs`        | billing address / ZIP mismatch (ANet code 27)     |
   * | `error_timeout`    | gateway timeout                                   |
   * | `error_transport`  | transport / connection failure                    |
   * | `error_no_method`  | payment method removed                            |
   */
  mode?: 'error' | 'error_declined' | 'error_avs' | 'error_timeout' | 'error_transport' | 'error_no_method';
}
